module.exports = __webpack_public_path__ + "static/media/Leccion-2-5-Caminando-En-Sus-Promesas.2d4cc42c.pdf";